export enum DIRECTION {
    RIGHT,
    DOWN,
    LEFT,
    UP,
    NUM_OF_DIRECTIONS
}
